var $class="se2--content-support-module",$name="ContentSupportModule",$path="app/components/ContentSupportModule/config.js",$this={$class,$name,$path,};export const lastSupportLinkSelector = 'div > div:last-child > a';
export const linkTagName = 'a';
export const supportLinkSelector = 'div > div > a';
export const supportModuleClassName = $class;
